import React, {useState} from 'react'
import BaseModal, { BaseModalContent } from "../BaseModal";
//import PersonIcon from '@material-ui/icons/Person';
import AddEmailModalForm from "../../Forms/profile/AddEmailModalForm";

const AddEmailModal=(props)=>{ 
    const {isOpenAddEmailModal,handleCloseAddEmailModal} = props;

    return(
        <>
            <BaseModal
                title="Driver Account Email"
                align="center"
                open={isOpenAddEmailModal}
                onClose={handleCloseAddEmailModal}
                fullWidth
            >
                <BaseModalContent>
                   <AddEmailModalForm handleClose={handleCloseAddEmailModal}/>
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default AddEmailModal;